import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
  Paper,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { loginSuccess, setLoading } from '../../features/authSlice';
import CarouselComponent from '../../common/components/CarouselComponent';
import LoginForm from './LoginForm';
import { login } from '../../api/authApi';
import { showNotification } from "../../common/components/Notification/ToastifyNotification";

const MentorLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { loading } = useSelector((state) => state.auth);

  const handleSubmit = async (values) => {
    try {
      dispatch(setLoading({
        loading: true
      }));
      const response = await login(values);
      if (response.data.token) {
        dispatch(loginSuccess({
          token: response.data.token,
        }));
        showNotification('Login Successfully', 'success');
        navigate('/mentor-dashboard');
      }
    } catch (err) {
      const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
      showNotification(errorMessage, 'error');
      dispatch(setLoading({
        loading: false
      }));
    }
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <Paper
        elevation={isMobile ? 0 : 3}
        sx={{
          width: '100%',
          height: '100%',
          borderRadius: 0,
          overflow: 'hidden',
        }}
      >
        <Grid container sx={{ height: '100%' }}>
          <Grid
            item
            xs={12}
            md={6.5}
            sx={{
              height: '100%',
              overflow: 'hidden',
              display: { xs: isMobile ? 'none' : 'flex', md: 'flex' },
            }}
          >
            <CarouselComponent />
          </Grid>
          <Grid
            item
            xs={12}
            md={5.5}
            sx={{
              height: '100%',
              overflowY: 'auto',
              display: 'flex',
              backgroundColor: 'white',
            }}
          >
            <LoginForm
              onSubmit={handleSubmit}
              loading={loading}
            />
          </Grid>
        </Grid>
        {isMobile && (
          <Box sx={{ height: '100%', overflowY: 'auto' }}>
            <LoginForm
              onSubmit={handleSubmit}
              loading={loading}
            />
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default MentorLogin;